module.exports = __webpack_public_path__ + "static/checkmark-mobile-26ea3c1bd663a73a36cd725c7f954e20.png";